module.exports = __webpack_public_path__ + "710f55cbc7ad18a104c90a396d2d28f7.pdf";